import { render, staticRenderFns } from "./OrderBook.vue?vue&type=template&id=037bd264&scoped=true&"
import script from "./OrderBook.vue?vue&type=script&lang=ts&"
export * from "./OrderBook.vue?vue&type=script&lang=ts&"
import style0 from "./OrderBook.vue?vue&type=style&index=0&id=037bd264&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "037bd264",
  null
  
)

export default component.exports